// @ts-nocheck
/* eslint-disable */
export const deleteOutlineIcon = {
    data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.00001 15.8333C5.00001 16.75 5.75001 17.5 6.66667 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V5.83333H5.00001V15.8333ZM6.66667 7.5H13.3333V15.8333H6.66667V7.5ZM12.9167 3.33333L12.0833 2.5H7.91667L7.08334 3.33333H4.16667V5H15.8333V3.33333H12.9167Z" fill="currentColor"/></svg>`,
    name: 'delete-outline' as const
};